import { baseApi } from "./api";

// Read-only RTK Query endpoints for the role reference screen.
// Roles are a fixed system set (managed via seeders, not the UI), so there are
// no mutations here - the global role permission matrix is informational.
export const roleApi = baseApi.injectEndpoints({
	endpoints: (build) => ({
		listRoles: build.query({
			query: () => ({ url: "roles" }),
			transformResponse: (res) => res?.items || [],
			providesTags: [{ type: "Role", id: "LIST" }],
		}),
		getRolePermissions: build.query({
			query: (roleId) => ({ url: `role-permissions/role/${roleId}` }),
			transformResponse: (rows) =>
				(rows || []).reduce(
					(map, r) => ({ ...map, [r.area]: r.permission }),
					{},
				),
			providesTags: (res, err, roleId) => [
				{ type: "RolePermission", id: roleId },
			],
		}),
	}),
});

export const { useListRolesQuery, useGetRolePermissionsQuery } = roleApi;
